import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { DayCell } from '@/domain/termine/features/Calendar/shared/DayCell/DayCell';
import { Feiertag } from '@/domain/termine/shared/types/Feiertag';
import { Termin } from '@/domain/termine/shared/types/Termin';
import { Day } from '@/domain/termine/type';
import { useTranslation } from 'react-i18next';

interface DayCellWrapperProps {
  day: Day;
  termineForDay: Termin[];
  isToday: boolean;
  hasFeiertag: (day: Day, feiertag: Feiertag[]) => boolean;
  isTodayInWeek: boolean;
  isTodayTermin: boolean;
}

export function ListDayCell({
  day,
  termineForDay,
  isToday,
  hasFeiertag,
  isTodayInWeek,
  isTodayTermin,
}: DayCellWrapperProps) {
  const { feiertage } = useCalendarContext();
  const { t } = useTranslation();
  if (termineForDay.length > 0) {
    return (
      <div className={hasFeiertag(day, feiertage) && 'py-2'}>
        <DayCell day={day} termine={termineForDay} />
      </div>
    );
  }
  if (isToday && isTodayInWeek && !isTodayTermin) {
    return (
      <div className="flex p-4 bg-neutrals-N300 w-full rounded-lg shadow-sm transition-colors justify-center">
        {t('domain.termine.heutekeinenTermin')}
      </div>
    );
  }
  return null;
}
